import { Button } from '@cian/ui-kit';

import { type FC, type JSX, useCallback } from 'react';

import { useListingLayoutGridTypeSelector } from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';

import { ChatButtonRendererContainer } from './ChatButtonRendererContainer';

export const CardChatButtonResponsiveContainer: FC = () => {
  const gridType = useListingLayoutGridTypeSelector();

  const render = useCallback(
    ({ onClick, loading }: { onClick: () => void; loading: boolean }): JSX.Element => (
      <Button
        fullWidth
        data-testid="card.chat-button"
        loading={loading}
        size={gridType === 'oneColumn' ? 'M' : 'XS'}
        theme="fill_secondary"
        onClick={onClick}
      >
        Написать
      </Button>
    ),
    [gridType],
  );

  return <ChatButtonRendererContainer render={render} />;
};
